import { useState } from 'react';

import { downloadImageBlob } from '@/services/storage';

interface DownloadButtonProps {
  path: string;
}

/**
 * Через blob, а не <a href={signedUrl} download> — атрибут download у
 * кросс-доменной ссылки ведёт себя непредсказуемо в разных браузерах,
 * а blob-ссылка того же происхождения скачивается надёжно везде.
 */
export function DownloadButton({ path }: DownloadButtonProps) {
  const [isDownloading, setIsDownloading] = useState(false);
  const [failed, setFailed] = useState(false);

  async function handleClick() {
    setIsDownloading(true);
    setFailed(false);

    try {
      const blob = await downloadImageBlob(path);
      if (!blob) {
        setFailed(true);
        return;
      }

      const url = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = path.split('/').pop() ?? 'portrait.png';
      document.body.appendChild(link);
      link.click();
      link.remove();
      URL.revokeObjectURL(url);
    } finally {
      setIsDownloading(false);
    }
  }

  return (
    <div>
      <button
        type="button"
        onClick={() => void handleClick()}
        disabled={isDownloading}
        className="btn btn-primary px-4 py-2 text-sm"
      >
        {isDownloading ? 'Скачивание…' : 'Скачать'}
      </button>
      {failed && <p className="mt-1 text-xs text-danger">Не удалось скачать файл. Попробуйте ещё раз.</p>}
    </div>
  );
}
